module.exports = __webpack_public_path__ + "static/media/p8.1f7ea441.jpeg";